import { IApiAdTargeting } from 'redux-state/advertisement/types.js';

export const buildAdTargeting = ({
  overrideBaseTargeting,
  mergeBaseTargeting,
  targeting = [],
  baseTarget,
}: {
  overrideBaseTargeting: boolean;
  mergeBaseTargeting: boolean;
  targeting?: IApiAdTargeting[];
  baseTarget: IApiAdTargeting[];
}): IApiAdTargeting[] => {
  if (overrideBaseTargeting) {
    return targeting;
  }
  if (mergeBaseTargeting) {
    return targeting.concat(baseTarget);
  }
  return baseTarget;
};
